import type { ReactNode } from 'react';
import { Description, Head, IconSlot, Wrapper } from './Section.styles';

type Props = {
  /** Leading icon describing the section (decorative). */
  icon: ReactNode;
  /** Accessible label for the section. */
  label: string;
  /** Bold description shown next to the icon. */
  description: ReactNode;
  /** The section control, e.g. a dropdown. */
  children: ReactNode;
};

/**
 * A labelled section of the regional settings: an icon and bold description
 * followed by a control (dropdown).
 */
const Section = ({ icon, label, description, children }: Props) => (
  <Wrapper aria-label={label}>
    <Head>
      <IconSlot aria-hidden="true">{icon}</IconSlot>
      <Description>{description}</Description>
    </Head>
    {children}
  </Wrapper>
);

export { Section };
